export default {"src":"/_next/static/media/percentage.7e5024c2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};